export const LOCATION_QUERY_PARAM = 'location';

/**
 * Carries the geocoded "City, ST" between the search page and a site detail
 * page: search results link to a site with it, and the site breadcrumb links
 * back with it so the search re-runs instead of landing on empty results.
 */
export const withLocationParam = (href: string, locality?: string): string => {
  if (!href || !locality) {
    return href;
  }

  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}${LOCATION_QUERY_PARAM}=${encodeURIComponent(locality)}`;
};

/** Location the current page was opened with. Empty on the server and on a cold start. */
export const getLocationParam = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  return (new URLSearchParams(window.location.search).get(LOCATION_QUERY_PARAM) ?? '').trim();
};
